import { UserDto } from '@act/shared/data-transfer-objects';
import { useEffect, useRef, useState } from 'react';
import ConfettiExplosion from 'react-confetti-explosion';

// from https://usehooks.com/usePrevious/
function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref = useRef();
  // Store current value in ref
  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes
  // Return previous value (happens before update in useEffect above)
  return ref.current;
}

export const EngageConfetti = ({ user }: { user: UserDto }) => {
  const previousMemberStatusKey = usePrevious(user?.memberStatus?.key);
  const currentMemberStatusKey = user?.memberStatus?.key;

  const previousMemberId = usePrevious(user?.id);
  const currentMemberId = user?.id;

  const [exploding, setExploding] = useState(false);
  const explode = () => {
    setExploding(true);
    setTimeout(() => {
      setExploding(false);
    }, 3000);
  };

  useEffect(() => {
    const isSameMember = previousMemberId === currentMemberId;
    const isFirstLoad = !previousMemberStatusKey;
    const statusChanged =
      !isFirstLoad && currentMemberStatusKey !== previousMemberStatusKey;
    const isEngaged = ['newly-engaged', 're-engaged'].includes(
      currentMemberStatusKey
    );

    if (isSameMember && statusChanged && isEngaged) {
      explode();
    }
  }, [currentMemberStatusKey]);

  return (
    <div>
      <div style={{ position: 'absolute', top: '25%', left: '50%' }}>
        {exploding && (
          <ConfettiExplosion
            force={0.8}
            duration={3000}
            particleCount={250}
            width={1600}
          />
        )}
      </div>
    </div>
  );
};
